module.exports = __webpack_public_path__ + "static/media/Fresh_blanco_crop_600x115.b6e65406.png";